import { render, staticRenderFns } from "./AddedDocs.vue?vue&type=template&id=1fdeaee3&scoped=true"
import script from "./AddedDocs.vue?vue&type=script&lang=js"
export * from "./AddedDocs.vue?vue&type=script&lang=js"
import style0 from "./AddedDocs.vue?vue&type=style&index=0&id=1fdeaee3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdeaee3",
  null
  
)

export default component.exports